<template>
    <div :key="key">
        <div class="text-right" v-if="showRateLink">
            <a class="text-danger" href="https://www.bk.mufg.jp/ippan/kinri/list_j/kinri/kawase.html" target="_blank">三菱ＵＦＪ銀行為替相場一覧表へのリンクはこちら</a>
        </div>

        <LogTable
            v-model="value"
            :fields="fields_matched"
            :defaultRow="{
            name: null,
            }"
            class="deal-items mt-3"
            :showBtnRowMove="false"
            :autoAddRow="true"
            ref="logTable"
            >
            <template v-slot:cell(fetch)="data">
                <SelectItemHscode
                    v-model="data.item.fetch"
                    @input="onInputItemId($event, data.item)"
                    />
            </template>
            <template v-slot:cell(quantity)="data">
                <b-form-input
                    v-model="data.item.quantity"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    placeholder="1"
                    v-base-numeral-format
                    ></b-form-input>
            </template>
            <template v-slot:cell(hs_code)="data">
                <b-form-input
                    v-model="data.item.hs_code"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    ></b-form-input>
            </template>
            <template v-slot:cell(country)="data">
                <SelectCountry
                    v-model="data.item.country"
                    />
            </template>
            <template v-slot:cell(product)="data">
                <b-form-input
                    v-model="data.item.product"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    ></b-form-input>
            </template>
            <template v-slot:cell(weight_net)="data">
                <b-form-input
                    v-model="data.item.weight_net"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(weight_gross)="data">
                <b-form-input
                    v-model="data.item.weight_gross"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(price)="data">
                <b-input-group size="sm" :prepend="currency">
                    <b-form-input
                        v-model="data.item.price"
                        size="sm"
                        style="height:2.45em;"
                        @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                        @focus="$event.target.select()"
                        class="text-right no-spin"
                        v-base-numeral-format="{&quot;float&quot;:true}"
                        ></b-form-input>
                </b-input-group>
            </template>
            <template v-slot:cell(subtotal)="data">
                {{ currency }}
                {{ get_item_subtotal(data.item, castPrice) | BaseNumberFormatter }}
            </template>
            <template v-slot:cell(box_no)="data">
                <b-form-input
                    v-model="data.item.box_no"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    placeholder="1"
                    v-base-numeral-format
                    ></b-form-input>
            </template>
        </LogTable>

        <b-row>
            <b-col cols="9" xl="10" class="text-right">
                <strong>
                    合計金額:
                    <br>
                    合計数量:
                </strong>
            </b-col>
            <b-col cols="3" xl="2" class="text-right">
                <strong>
                    {{ currency }}
                    {{ total.total_item_price | BaseNumberFormatter }}
                    <br>
                    {{ total.total_item_count | BaseNumberFormatter }}
                    個
                </strong>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectItemHscode from '@/components/SelectItemHscode.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        SelectCountry,
        SelectItemHscode,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Array,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
        currency: {
            type: String,
            default() {
                return 'JPY'
            },
        },
        showRateLink: {
            type: Boolean,
            default() {
                return true
            },
        },
        castPrice: {
            type: String,
            default() {
                return 'int'
            },
        },
        fields: {
            type: Array,
            default() {
                return [
                    'fetch',
                    'quantity',
                    'hs_code',
                    'country',
                    'product',
                    'weight_net',
                    'weight_gross',
                    'price',
                    'subtotal',
                ]
            },
        },
    },
    data() {
        return {
            key: 0,
            address_from_id: null,
            address_to_id: null,
            address_importer_id: null,

            order_query: '',
            order_type: 'word',
            data_orders: [],
            data_orders_selected: {},

            data_shipping: {},
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
            'get_item_subtotal',
            'get_items_total',
            'get_casted_price',
        ]),
        total() {
            let total = this.get_items_total(this.value, this.castPrice)
            this.$utils.touch(this.value)
            return total
        },
        fields_matched() {
            const fields_all = [
            { key: 'fetch', label: '選択', thStyle: { width: '8em', }, },
            { key: 'quantity', label: '数量', thStyle: { width: '4em', }, },
            { key: 'hs_code', label: 'HS CODE', thStyle: { width: '8em', }, },
            { key: 'country', label: '原産国(en)', thStyle: { width: '14em', }, },
            { key: 'product', label: '商品名称(en)', thStyle: { width: '16em', }, },
            { key: 'weight_net', label: '合計Net重量kg', thStyle: { width: '8em', }, },
            { key: 'weight_gross', label: '合計Gross重量kg', thStyle: { width: '8em', }, },
            { key: 'price', label: '単価', thStyle: { width: '16em', }, },
            { key: 'subtotal', label: '小計', thStyle: { width: '14em', }, tdClass: 'text-right align-middle', },
            { key: 'box_no', label: '梱包', thStyle: { width: '4em', }, tdClass: 'text-right align-middle', },
            ]
            return fields_all
                .filter((v) => {
                    return this.fields.includes(v.key)
                })
        },
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
        onInputItemId (value, row) {
console.log(value)
            let item = {
                quantity: null,
                hs_code: null,
                country: null,
                product: null,
                price: null,
                weight_net: null,
                weight_gross: null,
            }
            if (value) {
                switch (value.type) {
                    case 'item':
                        item = {
                            quantity: value.quantity,
                            hs_code: value.hs_code,
                            country: value.country,
                            product: value.product,
                            price: value.price,
                            weight_net: value.weight_net,
                            weight_gross: value.weight_gross,
                        }
                        break
                    case 'hscode':
                        item = {
                            hs_code: value.hs_code,
                            country: value.country,
                        }
                        break
                }
            }
            this.$utils.set(row, item)

            if (value && value.currency && this.currency !== value.currency) {
alert(
`
通貨を${value.currency}に一括設定しました。
`)
                this.$emit('onChangeCurrency', value.currency)
            }

            this.key++
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

